import { SidenavItem } from '@layout/sidenav/sidenav-item/sidenav-item.interface';

export const ESIC_CIDADAO_SIDENAV_ITEMS: SidenavItem[] = [
  {
    name: 'Principal',
    routeOrFunction: '/modulo/esic/cidadao/principal',
    icon: 'home',
    position: 10,
    pathMatchExact: true
  },
  {
    name: 'Registrar pedido',
    routeOrFunction: '/modulo/esic/cidadao/registrarpedido',
    icon: 'note_add',
    position: 20,
  },
  {
    name: 'Consultar pedido',
    routeOrFunction: '/modulo/esic/cidadao/pedido/consulta',
    icon: 'find_in_page',
    position: 30,
  },
  {
    name: 'Consultar recurso',
    routeOrFunction: '/modulo/esic/cidadao/recurso/consulta',
    icon: 'find_in_page',
    position: 40,
  },
];
